import callApi from 'utils/callApi';

// Requests
export function requestFetchChangeInfo({ limit, offset }) {
  return callApi('change/info/search/', 'POST', {
    limit,
    offset,
  });
}

export function requestSearchChangeInfo({ limit, offset, filters }) {
  return callApi('change/info/search/', 'POST', {
    filters,
    sort_by: [
      {
        name: 'Trading Partner Name',
        sort: 'asc',
      },
      {
        name: 'ID',
        sort: 'asc',
      },
    ],
    limit,
    offset,
  });
}



// WEBPACK FOOTER //
// ./src/redux/modules/changeInfo.js